export const environment = {
  production: true,
  backendUri: 'https://capstone-api.gung.io/',
  projectName: 'capstone'
};
